import { render, staticRenderFns } from "./rankingMensal.vue?vue&type=template&id=4261eda6"
import script from "./rankingMensal.vue?vue&type=script&lang=js"
export * from "./rankingMensal.vue?vue&type=script&lang=js"
import style0 from "./rankingMensal.vue?vue&type=style&index=0&id=4261eda6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports